// theme/shiftHue.js

/**
 * Shifts the hue of an OKLCH color string by a given number of degrees.
 * Example input: "74.703% 0.158 39.947"
 */
export function shiftHue(oklch, hueShift) {
  const match = oklch.match(/([\d.]+)%\s+([\d.]+)\s+([\d.]+)/);
  if (!match) {
    throw new Error(`Invalid OKLCH string: "${oklch}"`);
  }

  const [, lightnessStr, chromaStr, hueStr] = match;
  const lightness = parseFloat(lightnessStr);
  const chroma = parseFloat(chromaStr);
  const hue = (parseFloat(hueStr) - hueShift + 360) % 360;

  return `${lightness}% ${chroma} ${hue.toFixed(3)}`;
}
